import { useCallback, useEffect, useRef, useState } from 'react';
import { AdditionalIcon } from '../shared/additionalIcon/additionalIcon';
import { SlideoutBtnPosition, SlideoutWrapperProps } from './types/slideoutWrapperProps';
import './slideoutWrapper.scss';

const SlideoutWrapper = (props: SlideoutWrapperProps) => {
  const panel = useRef<HTMLDivElement>(null);
  const resizerHandle = useRef<HTMLDivElement>(null);
  const prevPos = useRef<number>(0);
  const prevWidth = useRef<number>(0);
  const [open, setOpen] = useState<boolean>(false);
  const [firstShow, setFirstShow] = useState<boolean>(false);

  const mousemove = useCallback((e: MouseEvent) => {
    if (panel.current) {
      const currentWidth = prevWidth.current;
      let newX = prevPos.current - e.x;
      if (panel.current) {
        const parentWidth = panel.current.parentElement?.clientWidth;
        if (parentWidth) {
          let percWidth = (currentWidth + newX) * 100 / parentWidth;
          const percMax = 100;
          const percMin = 400 / parentWidth;

          if (percWidth > percMax) {
            percWidth = percMax;
          }

          if (percWidth < percMin) {
            percWidth = percMin;
          }
          panel.current.style.width = `${percWidth}%`;
        }
      }
    }
  }, [])

  const mouseup = useCallback((e: MouseEvent) => {
    window.removeEventListener('mousemove', mousemove);
    window.removeEventListener('mouseup', mouseup);
  }, [mousemove])

  const resize = useCallback((e: MouseEvent) => {
    window.addEventListener('mousemove', mousemove);
    window.addEventListener('mouseup', mouseup);

    prevPos.current = e.x;
    if (panel.current) {
      prevWidth.current = panel.current.getBoundingClientRect().width;
    }
  }, [mousemove, mouseup])

  useEffect(() => {
    resizerHandle?.current?.addEventListener('mousedown', resize);
    //return resizerHandle?.current?.removeEventListener('mousedown', resize);
  }, [resize])

  const handleOpen = () => {
    if (panel.current) {
      panel.current.style.width = open ? "0" : "50%";
      setOpen(!open);

      if (!firstShow) {
        if (props.onFirstShow !== undefined) {
          props.onFirstShow();
        }
        setFirstShow(true);
      }
    }
  }

  const getBtnStyle = (disable?: boolean, hide?: boolean) => {
    if (props.btnPos === SlideoutBtnPosition.TopRight) {
      if (open) {
        var styleOpen: React.CSSProperties = {
          top: '18px',
          left: '-40px',
          borderRadius: '16px 0px 0px 16px',
          height: '40px',
          width: '40px'
        }
        if (disable) {
          styleOpen.background = "#C5BFB7";
          styleOpen.cursor = "default";
        }
        if (hide) {
          styleOpen.visibility = "hidden";
        }
        return styleOpen
      }
      var styleClosed: React.CSSProperties = {
        top: '18px',
        right: '28px',
        borderRadius: '4px',
        height: '40px',
        width: '40px'
      }
      if (disable) {
        styleClosed.background = "#C5BFB7";
        styleClosed.cursor = "default";
      } 
      if (hide) {
        styleClosed.visibility = "hidden";
      }  
      return styleClosed
    }
    return {
      top: 'calc(50% - 28px)',
      left: '-56px',
      borderRadius: '16px 0px 0px 16px'
    }
  }

  return (
    <div className="slideoutWrapper" ref={panel}>
      {props.children}
      <div>
        <div className="resizerHandle" ref={resizerHandle} />
        <div className="resizerHandleBtn" style={getBtnStyle(props.disable, props.hide)} onClick={() => {if (!props.disable && !props.hide) handleOpen()}}>
          {AdditionalIcon(props.icon)}
        </div>
      </div>
    </div>
  )
}

export default SlideoutWrapper;